/* MONT DEGRÉS v1 — fiche à cœur VÊTEMENTS (sections md-vet-*), 25/10/2026. Vanilla, sans dépendance.
   Ajouté à md-theme.js (variantes, galerie, panier) et md-coeur.js (extraits d'avis, taille de la barre collante) :
   conseiller taille et poids, paliers en une ligne avec filet quand le panier n'est pas vide, niveaux de chauffe, animations jouées une fois,
   packshot de l'appel final qui suit la couleur, questions repliées, barre collante cachée sur l'appel final.
   Sans script : tableau complet, niveau Moyen affiché, zones allumées. */
(()=>{
'use strict';
if(window.__mdVet)return;window.__mdVet=1;
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const eur=c=>(c/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/[  ]/g,' ')+' €';

function start(){
  const form=$('form[data-md-product-form]');
  const sizeSet=form&&$('[data-md-opt][data-required="true"]',form);
  const colorSet=form&&$('.md-vet-coul',form);
  const pick=sz=>{if(!sizeSet)return;const inp=$$('input',sizeSet).find(x=>x.value===sz);if(inp&&!inp.checked){inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));}};
  const rows=$$('[data-md-vet-tab] tbody tr');
  const surligner=t=>rows.forEach(r=>r.classList.toggle('is-on',r.dataset.t===t));

  /* Conseiller taille et poids : la plus grande des deux tailles (entre deux : au-dessus), ligne du tableau surlignée */
  const btn=$('[data-md-vet-cons-btn]'),cons=$('[data-md-vet-cons]');
  if(btn&&cons){
    btn.addEventListener('click',()=>{const o=cons.hidden;cons.hidden=!o;btn.setAttribute('aria-expanded',String(o));if(o){const h=$('input',cons);if(h)h.focus({preventScroll:true});}});
    let g=[];try{g=JSON.parse(($('[data-md-vet-grille]',cons)||{}).textContent||'[]');}catch(e){}
    const res=$('[data-md-vet-res]',cons),hI=$('[data-md-vet-h]',cons),pI=$('[data-md-vet-p]',cons);
    const rang=(v,k)=>g.findIndex(r=>v<=r[k]);
    /* 28/10/2026 (enfants) : conseiller âge/taille, la taille de l'enfant prime, l'âge seul donne une taille indicative */
    const aI=$('[data-md-vet-a]',cons);
    const choisir=(t,pre)=>{surligner(t);res.innerHTML='<span>'+pre+'&nbsp;: <b>'+t+'</b></span><button type="button">Choisir '+t+'</button>';
      $('button',res).addEventListener('click',()=>{pick(t);const b2=$('button',res);if(b2){b2.textContent='Taille '+t+' choisie ✓';}});};
    const calcE=()=>{
      const h=parseFloat(hI.value),a=parseFloat(aI.value);res.textContent='';if(!g.length)return;
      if(h>=90&&h<=190){
        if(h<g[0].hm){res.innerHTML='<span>Nos tailles commencent à '+g[0].hm+'&nbsp;cm.</span>';return;}
        const i=rang(h,'h');if(i<0){res.innerHTML='<span>Au-delà de '+g[g.length-1].h+'&nbsp;cm, passez aux tailles adultes.</span>';return;}
        choisir(g[i].t,'Taille conseillée');return;}
      if(a>=3&&a<=17){const i=rang(a,'a');if(i<0){res.innerHTML='<span>Au-delà de '+g[g.length-1].a+'&nbsp;ans, mesurez l’enfant&nbsp;: une taille adulte ira peut-être mieux.</span>';return;}
        choisir(g[i].t,'Taille indicative pour son âge');}
    };
    if(aI){hI.addEventListener('input',calcE);aI.addEventListener('input',calcE);}
    const calc=()=>{
      if(aI)return;
      const h=parseFloat(hI.value),p=parseFloat(pI.value);res.textContent='';
      if(!(h>=140&&h<=215)||!(p>=40&&p<=160)||!g.length)return;
      const a=rang(h,'h'),b=rang(p,'p');
      if(a<0||b<0){res.innerHTML='<span>Au-delà du '+g[g.length-1].t+'&nbsp;: <a href="/pages/contact">écrivez-nous</a>, réponse sous 24&nbsp;h ouvrées.</span>';return;}
      const r=g[Math.max(a,b)],t=r.t;surligner(t);
      /* 28/10/2026 (lot 3, audit client : repère concret, tiré du tableau du fabricant) */
      const rep=r.c?'<small class="md-vet-res__rep">Le '+t+' mesure '+r.c+'&nbsp;cm de tour de poitrine, soit '+String(r.c/2).replace('.',',')+'&nbsp;cm d’une aisselle à l’autre à plat&nbsp;: comparez avec une veste à vous.</small>':'';
      res.innerHTML='<span>Taille conseillée&nbsp;: <b>'+t+'</b></span><button type="button">Choisir '+t+'</button>'+rep;
      $('button',res).addEventListener('click',()=>{pick(t);const b2=$('button',res);if(b2){b2.textContent='Taille '+t+' choisie ✓';}});
    };
    /* 28/10/2026 (règle R, Polaire 8) : sans repères du fabricant, la veste du client mesurée à plat contre la demi-poitrine du tableau */
    const qI=$('[data-md-vet-q]',cons);
    const calcQ=()=>{
      const q=parseFloat(String(qI.value).replace(',','.'));res.textContent='';if(!(q>=40&&q<=80)||!g.length)return;
      const i=rang(q,'q');
      if(i<0){res.innerHTML='<span>Au-delà du '+g[g.length-1].t+'&nbsp;: <a href="/pages/contact">écrivez-nous</a>, réponse sous 24&nbsp;h ouvrées.</span>';return;}
      choisir(g[i].t,'Taille conseillée');
    };
    if(qI)qI.addEventListener('input',calcQ);
    else if(!aI){hI.addEventListener('input',calc);pI.addEventListener('input',calc);}
  }

  /* Paliers : filet de progression et « encore X € » seulement quand le panier contient un article */
  const pal=$('[data-md-vet-pal]');
  if(pal){
    const s1=+pal.dataset.s1,s2=+pal.dataset.s2,p1=pal.dataset.p1,p2=pal.dataset.p2,maxi=s2||s1;
    const f=$('.md-vet-pal__f',pal),fi=$('[data-md-vet-pal-f]',pal),x=$('[data-md-vet-pal-x]',pal);
    const maj=pn=>{
      f.hidden=!(pn>0);fi.style.setProperty('--w',Math.min(100,pn*100/maxi)+'%');
      if(!(pn>0)){x.textContent='';return;}
      if(pn<s1)x.textContent='Encore '+eur(s1-pn)+' pour −'+p1+' %';
      else if(s2&&pn<s2)x.textContent='−'+p1+' % appliqués · encore '+eur(s2-pn)+' pour −'+p2+' %';
      else x.textContent='−'+(s2?p2:p1)+' % appliqués';
    };
    maj(+pal.dataset.panier||0);
    const relire=()=>fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>maj(c.items_subtotal_price||0)).catch(()=>{});
    document.addEventListener('shopify:cart:lines-update',()=>setTimeout(relire,300));
  }

  /* Niveaux de chauffe : intensité des lueurs, température, autonomie */
  $$('[data-md-vet-niv]').forEach(g=>{
    const btns=$$('[role=radio]',g),sec=g.closest('section'),zph=$('[data-md-vet-zph]',sec),out=$('[data-md-vet-niv-out]',sec);
    const set=b=>{btns.forEach(x=>{x.setAttribute('aria-checked',x===b?'true':'false');x.tabIndex=x===b?0:-1;});
      if(zph)zph.style.setProperty('--lvl',b.dataset.o);
      if(out){const h=b.dataset.h,a=$('[data-md-vet-niv-a]',out),bar=$('.md-vet-bar',out);out.style.setProperty('--h',h||0);$('[data-md-vet-niv-t]',out).textContent=b.dataset.t;
        /* 28/10/2026 : autonomie non sourcée pour ce niveau = phrase sans chiffre, barre masquée */
        if(a)a.innerHTML=h?'environ <b data-md-vet-niv-h>'+h+'&nbsp;h</b> par charge':'moins longtemps qu’en doux';if(bar)bar.hidden=!h;}};
    btns.forEach((b,i)=>{b.addEventListener('click',()=>set(b));b.addEventListener('keydown',e=>{const d=e.key==='ArrowRight'||e.key==='ArrowDown'?1:e.key==='ArrowLeft'||e.key==='ArrowUp'?-1:0;if(!d)return;e.preventDefault();const n=btns[(i+d+btns.length)%btns.length];set(n);n.focus();});});
  });

  /* Animations d'arrivée, une fois par section : zones qui s'allument, témoins du bouton, ligne du mannequin surlignée */
  const anims=$$('[data-md-vet-anim]');
  const jouer=s=>{s.classList.add('is-on');if(s.dataset.mdVetMt&&!rows.some(r=>r.classList.contains('is-on')))surligner(s.dataset.mdVetMt);};
  if(reduce||!('IntersectionObserver' in window))anims.forEach(jouer);
  else{anims.forEach(s=>s.classList.add('is-armed'));
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){io.unobserve(e.target);requestAnimationFrame(()=>requestAnimationFrame(()=>jouer(e.target)));}}),{rootMargin:'0px 0px -30% 0px'});
    anims.forEach(s=>io.observe(s));}

  /* 03/11/2026 (phase 2a) : apparition douce au défilement, une fois ; sans script ou en mouvement réduit, rien n'est masqué */
  const revs=$$('[data-md-vet-rev]');
  if(revs.length&&!reduce&&'IntersectionObserver' in window){
    const ior=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){ior.unobserve(e.target);e.target.classList.add('is-in');}}),{rootMargin:'0px 0px -10% 0px'});
    revs.forEach(s=>{s.classList.add('is-rev');ior.observe(s);});}

  /* Appel final : le packshot suit la couleur choisie */
  const pk=$('[data-md-vet-pack]');
  if(pk&&colorSet){let m={};try{m=JSON.parse(pk.dataset.mdVetPack);}catch(e){}
    colorSet.addEventListener('change',e=>{const v=e.target.value;if(m[v]){pk.removeAttribute('srcset');pk.src=m[v];} /* 04/11/2026 : srcset (md-aimg) retiré au changement de couleur, sinon le navigateur garderait l'ancienne image */});}

  /* Citation des avis (variante H) : flèches à droite du prénom de chaque carte ; elles actionnent les flèches du carrousel (md-product.js) */
  const bav=$('.md-vet-bav'),tr=bav&&$('.md-bav__track',bav);
  if(tr){const orig=$$('.md-rvs__nav button',bav);
    const poser=()=>$$('.md-bavc small',tr).forEach(sm=>{if($('.md-vet-bav__nav',sm))return;const n=document.createElement('span');n.className='md-vet-bav__nav';
      orig.forEach(o=>{const b=document.createElement('button');b.type='button';b.textContent=o.textContent;b.setAttribute('aria-label',o.getAttribute('aria-label'));b.addEventListener('click',()=>o.click());n.appendChild(b);});
      const t=document.createElement('span');t.textContent=sm.textContent;sm.textContent='';sm.append(t,n);});
    poser();new MutationObserver(poser).observe(tr,{childList:true});}

  /* FAQ : questions repliées */
  $$('[data-md-vet-plus]').forEach(b=>{const box=document.getElementById(b.getAttribute('aria-controls'));if(!box)return;
    b.addEventListener('click',()=>{const o=box.hidden;box.hidden=!o;b.setAttribute('aria-expanded',String(o));});});

  /* Barre collante cachée quand le bouton de l'appel final est à l'écran */
  const fin=$('[data-md-vet-final-cta]');
  if(fin&&'IntersectionObserver' in window){new IntersectionObserver(es=>es.forEach(e=>document.documentElement.classList.toggle('md-vet-stk-off',e.isIntersecting))).observe(fin);}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
